import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'mc-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppHeaderComponent { }
